import React, {memo} from 'react';

const MainLayout = memo(({children = ''}) => {
  // navbar mestinya di sini
  return <div style={{height: '100%'}}>{children}</div>;
});

export default MainLayout;
